import { Point } from 'app/contracts/Geometry';

export interface TweenLookupTableParams {
	start: Point;
	end: Point;
	pointCount: number;
	ease?: Function;
}

export class TweenLookupTable {
	public generate(params: TweenLookupTableParams): Array<Point> {
		let ratio: number = 1 / params.pointCount;
		let easeValue: number; //0 - 1
		let postions: Array<Point> = [];
		let rangeX: number = params.end.x - params.start.x;
		let rangeY: number = params.end.y - params.start.y;

		Math.random() * 1;

		for (var t = 0; t <= 1; t += ratio) {
			easeValue = t;
			postions.push({
				x: params.start.x + easeValue * rangeX,
				y: params.start.y + easeValue * rangeY
			});
		}

		return postions;
	}

	public multiTween(tweens: Array<TweenLookupTableParams>): Array<Point> {
		var positions: Array<Point> = [];
		tweens.forEach((tween: TweenLookupTableParams) => {
			let p = this.generate(tween);
			positions = positions.concat(p);
		});

		return positions;
	}
}
